<template>
<div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
  <div>
    <v-container fluid class="ma-0 pa-0 mt-6">
      <v-row dense >
        <v-col class="text-center blue darken-4">
        <div class="topHeader">
          <label v-if="typeId.toUpperCase() == 'NAME'" class="white--text font-weight-bold">Incident Commanders<br />by Last Name</label>
          <label v-else class="white--text font-weight-bold">{{valueId}}<br />Incident Commanders</label>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0 ma-0">
          <v-list>
            <v-list-item-group
              active-class="blue--text"
            >
              <template v-for="(item, index) in ics">
                <v-list-item :key="index">
                  <!-- eslint-disable-next-line -->
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-1 font-weight-bold blue--text text--darken-4" v-text="item.name "></v-list-item-title>
                      <v-list-item-subtitle v-if="item.callsign != ''">{{ 'Yosemite ' + item.callsign }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <div >
                          <span v-if="item.alwaysavailable === true">
                            <v-btn class="error--text text--darken-3 mr-1" depressed small text icon color="green darken-4" @click="alwaysAvailableModal = true">
                              <v-icon>
                                mdi-star-circle
                              </v-icon>
                            </v-btn>
                          </span>
                          <label class="ma-0 pa-0">{{item.ictype + (item.trainee == true ? ' (T)':'')}}</label>
                        </div>
                      </v-list-item-subtitle>

                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text >
                        <v-btn v-if="item.homephone != null" class="mr-3" fab dark x-small  color="blue darken-4" :href="`tel:+1${item.homephone}`">
                          <v-icon small dark>mdi-phone</v-icon>
                        </v-btn>
                        <v-btn v-if="item.cellphone != null" class="mr-3" fab dark x-small color="green darken-4" :href="`tel:+1${item.cellphone}`">
                          <v-icon small dark>mdi-cellphone</v-icon>
                        </v-btn>

                        <v-btn depressed outlined medium text icon color="blue darken-4" :to="`/iclistselector/iclistby/${typeId}/${valueId}/${item.capid}`">
                            <v-icon >
                              mdi-chevron-right
                            </v-icon>
                        </v-btn>
                      </v-list-item-action-text>

                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-divider
                :key="item.name + index"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </div>

  <!-- Begin - Always Available Modal -->
  <v-dialog
    v-model="alwaysAvailableModal"
    persistent
    width="300"
    dark
  >
    <v-card
      color="blue darken-4"
    >
      <v-layout class="justify-center">
        <v-card-title class="text-center">Always Available</v-card-title>
      </v-layout>
      <v-card-text>
        <v-layout class="justify-center">
          <label class="text-center">This member is always available to contact for a mission.  Please make sure you have exhausted the list before reaching out.</label><br />
        </v-layout>

      </v-card-text>
      <v-layout  class="justify-center">
        <v-card-actions>
          <v-btn color="white" class="blue--text text--darken-4" @click="alwaysAvailableModal = false">Close</v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
  <!-- End - Always Available Modal -->                                 

  <!-- Begin - Loading Data Modal -->
  <v-dialog
    v-model="isLoading"
    hide-overlay
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        Loading Data...
        <v-progress-linear
          indeterminate
          rounded
          color="white"
          class="mb-0"
          height="20px"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- End - Loading Data Modal -->
</div> 
</template>

<script>


export default {
  name: 'ICList',
  props: {
    typeId: {
      type: String,
      default: null
    },
    valueId: {
      type: String,
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      isLoading: false,
      alwaysAvailableModal: false,
      ics: [],
      background: "background-color: palegreen;"
    }
  },
  mounted() {
    this.getICList();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getICList() {

      this.isLoading = true;


      var obj = {
          wing: this.selWing,
          type: this.typeId
      };

      this.$https.post(this.$vars.BaseUrl + this.$vars.GetICListRoute, obj, this.$vars.config)
      .then(response => {
        //console.log(response);
        this.httpResponse = response;
        var resultData = response.data;
        if(this.typeId.toUpperCase() == 'ZONE')
        {
          const result = resultData.filter(item => (item.area == this.valueId && item.inactive != true));
          this.ics = result;
          this.setICList(result);
        }

        if(this.typeId.toUpperCase() == 'TYPE')
        {
          const result = resultData.filter(item => (item.ictype == this.valueId && item.inactive != true));
          this.ics = result;
          this.setICList(result);
        }

        if(this.typeId.toUpperCase() == 'NAME')
        {
          const result = resultData.filter(item => (item.inactive != true));
          this.ics = result;
          this.setICList(result);
        }


        this.isLoading = false;
      })
      .catch(e => {
        console.log(e);
        this.isLoading = false;
      });

    }
  }
}
</script>

<style scoped>
  .topHeader {
    height:55px
  }
</style>
